import { render, staticRenderFns } from "./LunchMenuFilters.vue?vue&type=template&id=7d48517a&scoped=true&"
import script from "./LunchMenuFilters.vue?vue&type=script&lang=js&"
export * from "./LunchMenuFilters.vue?vue&type=script&lang=js&"
import style0 from "./LunchMenuFilters.vue?vue&type=style&index=0&id=7d48517a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d48517a",
  null
  
)

export default component.exports